import React from 'react';
import ReactDOM from 'react-dom';
import Subpage from './Subpage';
import './stylesheets/lightbox.css'
import './index.css'
import * as serviceWorker from './serviceWorker';

require("lightbox2")
ReactDOM.render(<Subpage site='crrp' />, document.getElementById('root'));

serviceWorker.unregister();
